var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterCheckmark = function SvgFilterCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.473 8.626-1.904.169.883-1.05 1.02.881zM11.548.5c.535-.636 1.432-.668 2.003-.073.572.595.601 1.594.066 2.23L5.756 12 .549 7.506C-.07 6.972-.182 5.981.297 5.293c.48-.688 1.37-.814 1.99-.28l3.165 2.732L11.548.5z",
    fill: "currentColor"
  })));
};
export default SvgFilterCheckmark;